// extracted by mini-css-extract-plugin
export default {"wrapper":"DropModal_wrapper__zQhKh","action":"DropModal_action__Bu3u2","bead":"DropModal_bead__XglFG"};